module.exports = __webpack_public_path__ + "static/media/csrd_dc.554b3a9c.svg";